module.exports = __webpack_public_path__ + "img/carte-confituur-grafisch-ontwerp-yasmine-ontwerpbureau-nazareth-de-pinte.37f04098.png";